
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#939393","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.273 5.897A1.54 1.54 0 014.82 4.364h14.36a1.54 1.54 0 011.547 1.533v10.155a1.54 1.54 0 01-1.547 1.533h-7.794a.527.527 0 00-.309.1l-2.26 1.65c-1.021.746-2.464.023-2.464-1.235a.518.518 0 00-.52-.515H4.82a1.54 1.54 0 01-1.547-1.533V5.897zm1.09.067v10.045c0 .281.232.51.517.51h1.004c.847 0 1.534.678 1.534 1.516 0 .418.482.658.822.41l2.243-1.633a1.55 1.55 0 01.908-.294h7.73a.513.513 0 00.515-.51V5.965a.513.513 0 00-.516-.51H4.88a.513.513 0 00-.516.51zm3.758 7.672c-.268 0-.485-.244-.485-.545 0-.301.217-.546.485-.546h7.758c.268 0 .485.245.485.546 0 .301-.217.545-.485.545H8.12zm0-4.363c-.268 0-.485-.244-.485-.546 0-.301.217-.545.485-.545h7.758c.268 0 .485.244.485.545 0 .302-.217.546-.485.546H8.12z"}})])
          )
        }
      }
    